import React, { useCallback, useEffect, useState } from "react";
import { Download, Check, Trash2, Bell, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, whatsappLink } from "../lib/api";

export function CityLeadsAdmin() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState("");

  const load = useCallback(() => api.get("/admin/city-alerts").then((r) => setData(r.data)).catch(console.error), []);
  useEffect(() => { load(); }, [load]);

  const exportCsv = async () => {
    try {
      const res = await api.get("/admin/city-alerts/export.csv", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `leads-villes-${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 15000);
    } catch { toast.error("Erreur lors de l'export"); }
  };

  const markContacted = async (id) => {
    try { await api.patch(`/admin/city-alerts/${id}/contacted`); toast.success("Lead marqué contacté"); load(); }
    catch { toast.error("Erreur"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Supprimer ce lead ?")) return;
    try { await api.delete(`/admin/city-alerts/${id}`); load(); }
    catch { toast.error("Erreur"); }
  };

  if (!data) return <p className="text-zinc-500">Chargement...</p>;
  return (
    <div data-testid="admin-city-leads">
      <div className="flex flex-wrap items-center gap-3 mb-5">
        <div>
          <h2 className="font-anton text-2xl uppercase text-white">Leads villes <span className="text-neon-magenta">({data.total})</span></h2>
          <p className="text-zinc-500 text-xs">Clients qui attendent un livreur. Priorise le recrutement là où ça déborde, et contacte-les quand un vendeur ouvre.</p>
        </div>
        <button data-testid="city-leads-export" onClick={exportCsv} className="ml-auto flex items-center gap-1.5 text-xs uppercase font-bold border border-neon-green text-neon-green px-3 py-2 hover:bg-neon-green hover:text-black transition-colors"><Download className="h-4 w-4" /> Export CSV</button>
      </div>
      {data.cities.length === 0 && <p className="text-zinc-500 border border-zinc-800 p-6 text-center">Aucun lead pour le moment.</p>}
      <div className="space-y-2">
        {data.cities.map((c) => (
          <div key={c.city} className="bg-ink-surface border border-zinc-800" data-testid="city-leads-group">
            <button onClick={() => setOpen(open === c.city ? "" : c.city)} className="w-full flex items-center gap-3 px-4 py-3 text-left">
              <Bell className={`h-4 w-4 ${c.to_contact > 0 ? "text-neon-green animate-pulse" : "text-neon-magenta"}`} />
              <span className="font-anton uppercase text-white text-lg">{c.city}</span>
              <span className="text-zinc-400 text-sm" data-testid="city-leads-count">{c.count} lead{c.count > 1 ? "s" : ""}</span>
              {c.to_contact > 0 && <span className="text-[10px] uppercase font-bold bg-neon-green text-black px-2 py-0.5">{c.to_contact} à contacter</span>}
              <span className="ml-auto text-zinc-500 text-xs">{open === c.city ? "▲" : "▼"}</span>
            </button>
            {open === c.city && (
              <div className="border-t border-zinc-800 divide-y divide-zinc-900">
                {c.leads.map((l) => (
                  <div key={l.id} className="flex flex-wrap items-center gap-3 px-4 py-2.5 text-sm" data-testid="city-lead-row">
                    <span className="text-white font-mono">{l.phone}</span>
                    <span className="text-zinc-600 text-xs">{new Date(l.created_at).toLocaleDateString("fr-FR")}</span>
                    {l.vendor_live_at && !l.contacted_at && <span className="text-[10px] uppercase font-bold text-neon-green border border-neon-green/50 px-1.5 py-0.5">Vendeur {l.vendor_live_name || ""} en ligne → à prévenir</span>}
                    {l.contacted_at && <span className="text-[10px] uppercase font-bold text-zinc-500">Contacté le {new Date(l.contacted_at).toLocaleDateString("fr-FR")}</span>}
                    <span className="ml-auto flex items-center gap-1.5">
                      <a href={whatsappLink(l.phone, `Salut ! STUFF CBD : un livreur est maintenant dispo à ${c.city} 🌿 Commande ici : ${window.location.origin}/livraison-cbd/${c.city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`)} target="_blank" rel="noopener noreferrer" data-testid="city-lead-whatsapp" className="p-1.5 border border-zinc-700 text-neon-green hover:bg-neon-green hover:text-black transition-colors" title="WhatsApp"><MessageCircle className="h-4 w-4" /></a>
                      {!l.contacted_at && <button onClick={() => markContacted(l.id)} data-testid="city-lead-contacted" className="p-1.5 border border-zinc-700 text-zinc-300 hover:text-neon-green transition-colors" title="Marquer contacté"><Check className="h-4 w-4" /></button>}
                      <button onClick={() => remove(l.id)} data-testid="city-lead-delete" className="p-1.5 border border-zinc-700 text-zinc-500 hover:text-red-400 transition-colors" title="Supprimer"><Trash2 className="h-4 w-4" /></button>
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
